module.exports = __webpack_public_path__ + "static/img/z2.c33319d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/association/z2.png
// module id = sPjv
// module chunks = 0